import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { functionUtils } from 'utils';
import ChangePickupLocationTypePopup from '../popups/ChangePickupLocationTypePopup';

const ChangePickupLocationTypeModal = ({
  isShow,
  title,
  content,
  action,
  actionClose,
}) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();
  const { isDesktop } = useDetectDevice();

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
    closePortalModalName();
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
    closePortalModalName();
  };

  return (
    <ChangePickupLocationTypePopup
      isOpen={isShow}
      imageSrc={NoticeIcon}
      imagesStyles={{
        width: '75px',
        height: '60px',
      }}
      text={title || ''}
      content={content || ''}
      buttonLabel1={t('button_no')}
      onClose={handleOnClose}
      buttonLabel2={t('button_yes')}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
    />
  );
};

export default ChangePickupLocationTypeModal;
